"use client";

import NavLink from "@/components/atoms/navbar/nav-link/NavLink";
import { useWishlist } from "@/hooks/useWishlist";
import { Locales } from "@/lib/i18n";
import { __, getPermalink } from "@/lib/i18n/client.functions";
import React from "react";

type WishlistButtonProps = {
  locale: Locales;
  icon?: boolean;
};

const WishlistButton = ({ locale, icon = false }: WishlistButtonProps) => {
  const { lists, isLoading } = useWishlist();
  const listsCount = isLoading || !lists || lists.length === 0 ? undefined : lists.length;

  return (
    <NavLink
      navLink={{ label: __("My favorites", locale), link: getPermalink(locale, "account", "wishlist") }}
      icon={icon ? "HeartIcon" : undefined}
      count={listsCount}
    />
  );
};

export default WishlistButton;
